import {Component, EventEmitter, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../services/Toast.service";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {StateService} from "../../services/StateService";
import {SwitchBoard} from "../../services/SwitchBoard";
import {ActivatedRoute, Router} from "@angular/router";
import {LoadingService} from "../../services/LoadingService";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../tpiq-services/manage-tax-strategies.service";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";
import {PageTitleService} from "../../services/PageTitle";
import {GrowthPlanService} from "../../tpiq-services/growth-plan.service";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {OneOnOneComponent} from "./one-on-one/one-on-one.component";
import {v4 as uuid} from 'uuid';
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";
import {TpiqFroalaViewComponent} from "../../tpiq-froala-view/tpiq-froala-view.component";
import {TpiqCustomDatepicker} from "../../directives/tpiq-custom-datepicker";
import {environment} from '../../../environments/environment';

declare const _: any;
declare const moment: any;

@Component({
  selector: 'app-growth-plan',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, OneOnOneComponent, FileUploadModule, FroalaEditorModule,
    MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule, TpiqFroalaViewComponent, TpiqCustomDatepicker],
  templateUrl: './growth-plan.component.html',
  styleUrl: './growth-plan.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class GrowthPlanComponent implements OnInit, OnDestroy {
  org: string = Session.getOrg();
  user: any = {};
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  editMode: boolean = false;
  reveal: any = {
    editPlan: false,
    showEvent: false,
    additionalResources: false,
    oneOnOneEdit: false
  };
  plan: any = {
    type: 'growth',
    location: 'Online, private'
  };

  upcomingEvents: Array<any> = [];
  normalEvents: Array<any> = [];
  editorOptions = {
    heightMin: 100,
    heightMax: 100,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Enter description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  selectedEvent: any;
  additionalResources = [];
  minDate: any;
  startIndex = 0;
  endIndex = 4; // Display 4 items at a time
  visibleUsers: Array<any> = [];
  uploader: FileUploader;
  hasBaseDropZoneOver: boolean;
  logoFiles = [];
  resourceLogoFiles = [];
  createOrEditResource = false;
  createTemplates = false;
  currentSelectedEventsType = "Upcoming Growth Events";
  categoryList = [];
  emailTemplateList = [];
  template : any = {
      files : [],
      categoryId: null,
      templateName : ''
  };
  revealTemplate: any = {
    additionalTemplate : false
  };

  resourceUploader: FileUploader;
  templateUploader : FileUploader;
  resourceImageUploader: FileUploader;
  resource: any = {
    files: [],
    pinned: false
  };
  hasImageBaseDropZoneOver: boolean;
  resourceEditMode = false;

  frequencyTypes: Array<any> = [{name: 'Weekly'}, {name: 'Monthly'}];
  oneOnOneEvent: any = {
    name: 'One on One Firm Consultation',
    description: 'A 30-minute consult with one of our Tax Experts',
    location: 'Online, Private',
    link: '',
    thumbnailUrl: ''
  };
  showPage = false;
  currentEnvironment: any;
  staticFileId: any;
  selectedGrowthPlanMarketingType = "Prospects";


  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private titleService: PageTitleService,
    private loadingService: LoadingService,
    private stateService: StateService,
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private growthPlanService: GrowthPlanService,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {
    this.currentEnvironment = environment;
  }

  ngOnInit(): void {
    this.loadingService.triggerLoadingEvent(true);
    this.titleService.setPageTitle('Growth Plan');
    this.user = Session.getUser();
    this.minDate = moment().format('MM/DD/YYYY');
    this.getOneOnOneEventData();
    this.getAllPlansData();
    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      const prevState = this.stateService.getPrevState();
      if (prevState) {
        this.stateService.pop();
        this._router.navigate([prevState.url]);
      }
    });
    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast.data) {
        if (toast.data.type && toast.data.type === 'deleteResource') {
          this.removeResource(toast.data.resourceId);
        } else if (toast.data.type && toast.data.type === 'deleteTemplate'){
          this.removeEmailTemplate(toast.data.templateId);
        } else {
          this.removeEventPlan(toast.data);
        }
      }
    });
    this.setGrowthPlanMarketingProgramTabFileId();
  }

  getAllPlansData() {
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.getAllPlans(this.org, this.user.id, 'growth')
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.normalEvents = response.schedules;
        _.each(this.normalEvents, (event) => {
          event.logoBg = {
            background: 'url("' + event.thumbnailUrl + '") center center no-repeat',
            'background-size': 'contain'
          };
          event.timeValue = this.formatedTimeValue(event);
        });
        this.upcomingEvents = response.upcomingEvents || [];
        _.each(this.upcomingEvents, (event) => {
          event.logoBg = {
            background: 'url("' + event.thumbnailUrl + '") center center no-repeat',
            'background-size': 'contain'
          };
          event.timeValue = this.formatedTimeValue(event);
        });
        this.updateVisibleEvents();
	this.loadingService.triggerLoadingEvent(false);
        setTimeout(() => {
          this.showPage = true;
        });
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To get growth plans data`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  eventRegisterLink(event) {
    if (event.link) {
      window.open(event.link);
    }
  }

  bookCallWithTaxExpert() {
    window.open('https://meetings.hubspot.com/veronica-herrera/growth-plan-1-to-1-session?uuid=56dc2289-7196-46e9-af13-b239fd8d5695');
  }

  hideReveal(revealFlag) {
    this.plan = {
      type: 'growth',
      location: 'Online, private'
    };
    this.resource = {
      files: []
    };
    this.template = {
      files : [],
      categoryId: null,
      templateName : ''
  };
    this.createOrEditResource = false;
    this.createTemplates = false;
    this.logoFiles = [];
    this.reveal[revealFlag] = false;
    this.revealTemplate[revealFlag] = false;
  }

  selectEventType(type) {
    if (type === 'Upcoming Growth Events') {
      this.currentSelectedEventsType = type;
    } else if (type === 'Growth Plan Marketing Program') {
      this.currentSelectedEventsType = type;
      this.getGrowthPlanCategoryList();
      this.getGrowthPlanEmailTemplateList();
      this.setEmailTemplateFileUploader();

    } else if (type === 'Step by Step Tax Planning Guides') {
      this.currentSelectedEventsType = type;
      this.getAdditionalResources();
    }
  }

  selectGrowthPlanMarketingType(type){
    this.selectedGrowthPlanMarketingType = type;
    this.getGrowthPlanEmailTemplateList();
  }

  createOrEditPlan() {
    if (this.validateData()) {
      this.loadingService.triggerLoadingEvent(true);
      this.growthPlanService.createOrEditPlan(this.org, this.user.id, this.plan)
        .subscribe((response) => {
          this.loadingService.triggerLoadingEvent(false);
          const successMsg = (this.editMode) ? 'Growth Plan updated successfully' : 'Growth Plan created successfully';
          this.toastService.pop(TOAST_TYPE.success, successMsg);
          this.hideReveal('editPlan');
          this.resetUploader();
          this.getAllPlansData();
        }, (error) => {
          this.loadingService.triggerLoadingEvent(false);
          const message = error.message ? error.message : `Failed To create/update Growth plan`;
          try {
            this.toastService.pop(TOAST_TYPE.error, message);
          } catch (e) {
            this.toastService.pop(TOAST_TYPE.error, message);
          }
        });
    }
  }

  validateData() {
    if (!this.plan.name) {
      this.toastService.pop(TOAST_TYPE.error, 'Title is mandatory');
      return false;
    }
    if (!this.plan.description) {
      this.toastService.pop(TOAST_TYPE.error, 'Description is mandatory');
      return false;
    }
    if (this.plan.recurring) {
      if (!this.plan.startDate) {
        this.toastService.pop(TOAST_TYPE.error, 'Start Date is mandatory');
        return false;
      }
      if (!this.plan.endDate) {
        this.toastService.pop(TOAST_TYPE.error, 'End Date is mandatory');
        return false;
      }
    } else {
      if (!this.plan.date) {
        this.toastService.pop(TOAST_TYPE.error, 'Date is mandatory');
        return false;
      }
    }
    if (!this.plan.timeRange) {
      this.toastService.pop(TOAST_TYPE.error, 'Time is mandatory');
      return false;
    }
    return true;
  }

  showEventInfo(event) {
    this.selectedEvent = event;
    this.reveal.showEvent = true;
  }

  createEvent() {
    this.reveal.editPlan = true;
    this.editMode = false;
    this.uploaderUpdate();
    this.buildItemForm();
  }

  showAdditionalResources() {
    this.reveal.additionalResources = true;
    this.getAdditionalResources();
  }

  setPlanDate($event, type?) {
    if (type && type === 'start') {
      this.plan.startDate = $event;
    } else if (type && type === 'end') {
      this.plan.endDate = $event;
    } else {
      this.plan.date = $event;
    }
  }

  previous() {
    if (this.startIndex > 0) {
      this.startIndex--;
      this.endIndex--;
      this.updateVisibleEvents();
    }
  }

  next() {
    if (this.endIndex < this.upcomingEvents.length) {
      this.startIndex++;
      this.endIndex++;
      this.updateVisibleEvents();
    }
  }

  updateVisibleEvents() {
    this.visibleUsers = this.upcomingEvents.slice(this.startIndex, this.endIndex);
    const eventColors = ['#ECFDF3', '#EFF8FF', '#F8F2FF', '#FFF6DC'];
    _.each(this.visibleUsers, (event, i) => {
      event.bgColor = eventColors[i] || eventColors[0];
    });
  }

  fileDropOver($event, type?){
    this.loadingService.triggerLoadingEvent(true);
    if (type && type === 'resource') {
      this.resourceUploader.uploadAll();
    } else if(type && type === 'image') {
      this.resourceImageUploader.uploadAll();
    } else if (type && type === 'template'){
      this.templateUploader.uploadAll();
    } else {
      this.uploader.uploadAll();
    }
  }

  fileOverBase($event, type?){
    if (type && type === 'image') {
      this.hasImageBaseDropZoneOver = $event;
    } else {
      this.hasBaseDropZoneOver = $event;
    }
  }

  uploaderUpdate() {
    const base = this;
    const docUrl: any = this.taxStrategyServices.getFirmLogoUrl(this.org, Session.getUser().id);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [
        {
          name: 'Authorization',
          value: 'Bearer ' + Session.getToken()
        }
      ]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  buildItemForm() {
    const base = this;
    const user: any = Session.getUser();
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceType = "firm_logo";
      payload.sourceId = uuid();
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploader.progress = 100;
        const document: any = JSON.parse(response);
        this.plan.thumbnailUrl = document.temporaryURL;
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.temporaryURL;
          this.logoFiles = [];
          this.logoFiles.push(obj);
        }
        this.loadingService.triggerLoadingEvent(false);
      } else {
        this.resetUploader();
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Upload Logo');
        this.loadingService.triggerLoadingEvent(false);
      }
    };
  }

  resetUploader(type?) {
    if (type && type === 'resource') {
      this.resourceUploader.queue.forEach((item) => {
        item.remove();
      });
    } else if (type && type === 'image') {
      this.resourceImageUploader.queue.forEach((item) => {
        item.remove();
      });
    } else if (type && type === 'template'){
      this.templateUploader.queue.forEach((item) => {
        item.remove();
      });
    } else {
      this.uploader.queue.forEach((item) => {
        item.remove();
      });
    }
  }

  deleteDocumentFile(file, index, type?){
    if (type && type === 'resource') {
      this.resource.files.splice(index, 1);
    } else if (type && type === 'resource image') {
      this.resourceLogoFiles.splice(index, 1);
      if (this.resourceLogoFiles.length === 0) {
        this.resource.thumbnailUrl = '';
      }
    } else if (type && type === 'replay') {
      this.plan.replays.splice(index,1);
    } else if (type && type === 'template'){
      this.resource.files.splice(index, 1);
    } else {
      this.logoFiles.splice(index, 1);
      if (this.logoFiles.length === 0) {
        this.plan.thumbnailUrl = '';
      }
    }
  }

  openEventForEdit(event) {
    this.reveal.editPlan = true;
    this.editMode = true;
    this.plan = _.cloneDeep(event);;
    this.uploaderUpdate();
    this.buildItemForm();
  }

  deleteEvent(event) {
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', event);
  }

  removeEventPlan(event) {
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.removePlan(this.org, this.user.id, event.id)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Growth Plan event deleted successfully');
        this.getAllPlansData();
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to delete growth plan event`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  uploadResource() {
    this.resource = {
      files: []
    };
    this.createOrEditResource = true;
    this.resourceEditMode = false;
    this.reveal.additionalResources = true;
    this.setFileUploader();
    this.setImageUploader();
  }

  uploadTemplate(){
    this.template = {
      files : [],
  };
  this.revealTemplate.additionalTemplate = true;
  this.createTemplates = true;
  }


  setEmailTemplateFileUploader() {
    const base = this;
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, this.user.id);
    this.templateUploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.templateUploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.templateUploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = uuid();
      payload.sourceType = 'GROWTH_PLAN_EMAIL_TEMPLATE';
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.templateUploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.templateUploader.progress = 100;
        const document: any = JSON.parse(response);
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.viewDocContentURL;
          obj['fileType'] = this.getFileType(document);
          this.template.files.push(obj);
        }
      } else {
        this.resetUploader('template');
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload document(s)');
      }
    };
  }

  setFileUploader() {
    const base = this;
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, this.user.id);
    this.resourceUploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.resourceUploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.resourceUploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = uuid();
      payload.sourceType = 'GROWTH_PLAN_RESOURCE_FILE';
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.resourceUploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.resourceUploader.progress = 100;
        const document: any = JSON.parse(response);
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.viewDocContentURL;
          obj['fileType'] = this.getFileType(document);
          this.resource.files.push(obj);
        }
      } else {
        this.resetUploader('resource');
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload document(s)');
      }
    };
  }

  getFileType(file) {
    let type = '';
    const splitArray = file.name.split('.');
    if (splitArray[splitArray.length - 1] === 'pdf' || splitArray[splitArray.length - 1] === 'PDF') {
      type = 'pdf';
    } else if (this.isExcel(splitArray[splitArray.length - 1])) {
      type = 'excel';
    } else if (this.isImage(splitArray[splitArray.length - 1])) {
      type = 'image';
    } else if (this.isVideo(splitArray[splitArray.length - 1])) {
      type = 'video';
    }

    return type;
  }

  isExcel(extension){
    const types = ['xls', 'xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xlt', 'xltm', 'xltm', 'xltm'];
    if (types.indexOf(extension.toLowerCase()) !== -1) {
      return true;
    }else {
      return false;
    }
  }

  isImage(extension){
    const types = ['png', 'jpg', 'jpeg'];
    if (types.indexOf(extension.toLowerCase()) !== -1) {
      return true;
    }else {
      return false;
    }
  }

  isVideo(extension){
    const types = ['mp4', 'mov', 'wmv', 'mkv'];
    if (types.indexOf(extension.toLowerCase()) !== -1) {
      return true;
    }else {
      return false;
    }
  }

  toggleCreateResource() {
    this.resource = {
      files: []
    };
    this.reveal.additionalResources = false;
    this.createOrEditResource = !this.createOrEditResource;
  }

  toggleCreateTemplate(){
    this.template = {
      files: [],
      categoryId: null,
      templateName : ''
    };
    this.revealTemplate.additionalTemplate = false;
    this.createTemplates = !this.createTemplates;
  }

  setImageUploader() {
    const base = this;
    const docUrl = this.taxStrategyServices.getFirmLogoUrl(this.org, this.user.id);
    this.resourceImageUploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.resourceImageUploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.resourceImageUploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceId = uuid();
      payload.sourceType = 'firm_logo';
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.resourceImageUploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.resourceImageUploader.progress = 100;
        const document: any = JSON.parse(response);
        this.resource.thumbnailUrl = document.temporaryURL;
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.temporaryURL;
          this.resourceLogoFiles = [];
          this.resourceLogoFiles.push(obj);
        }

      } else {
        this.resetUploader('image');
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload image(s)');
      }
    };
  }

  getAdditionalResources() {
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.getAdditionalResources(this.org, this.user.id)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.additionalResources = response.resources || [];
        _.each(this.additionalResources, (resource) => {
          resource.files = JSON.parse(resource.files) || [];
          resource.pinned = !!resource.pinned;
          resource.logoBg = {
            background: 'url("' + resource.thumbnailUrl + '") center center no-repeat',
            'background-size': 'contain'
          };
        });
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To get resources data`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

 

  getGrowthPlanCategoryList(){
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.getCategoryList(this.org, this.user.id)
    .subscribe((response) => {
      this.loadingService.triggerLoadingEvent(false);
      this.categoryList = response.categories || [];
    },(error) => {
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : `Failed To get category list`;
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });
  }

  getGrowthPlanEmailTemplateList(){
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.getEmailTemplateList(this.org, this.user.id, this.selectedGrowthPlanMarketingType)
    .subscribe((response) => {
      this.loadingService.triggerLoadingEvent(false);
      const templates = response.template || [];
      // Group templates by categoryId
      this.emailTemplateList = templates.reduce((acc, curr) => {
        const existingCategory = acc.find(item => item.categoryId === curr.categoryId);

        const templateEntry = {
          templateId: curr.templateId,
          templateName: curr.templateName,
          docLocation: JSON.parse(curr.docLocation)
        };

        if (existingCategory) {
          existingCategory.templates.push(templateEntry);
        } else {
          acc.push({
            categoryId: curr.categoryId,
            categoryName: curr.categoryName,
            templates: [templateEntry]
          });
        }

        return acc;
      }, []);
    },(error) => {
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : `Failed To get email template list`;
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });
  }

  removeEmailTemplate(templateId) {
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.getRemoveEmailTemplate(this.org, this.user.id, templateId)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Email Template deleted successfully');
        this.getGrowthPlanEmailTemplateList();
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to delete template`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  saveGrowthPlanEmailTemplate() {

     if (!this.template.audience) {
      this.toastService.pop(TOAST_TYPE.error, 'Please select a Audience');
      return;
    }

    if (!this.template.categoryId) {
      this.toastService.pop(TOAST_TYPE.error, 'Please select a Category');
      return;
    }

    if(!this.template.templateName){
      this.toastService.pop(TOAST_TYPE.error, 'Please add Template Title');
      return;
    }

    if (!this.template.files || this.template.files.length === 0) {
      this.toastService.pop(TOAST_TYPE.error, 'Please upload Email Template File');
      return;
    }

    let templateObj = _.cloneDeep(this.template);
    templateObj.docLocation = JSON.stringify(templateObj.files);
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.createEmailTemplate(this.org, this.user.id, templateObj)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        const successMsg = 'Email Template created successfully';
        this.toastService.pop(TOAST_TYPE.success, successMsg);
        this.createTemplates = false;
        this.revealTemplate.additionalTemplate = false;
        this.template = {
          files: [],
          categoryId: null,
          templateName : ''
        };
        this.getGrowthPlanEmailTemplateList();
        this.resetUploader('template');
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To upload template`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }


  createOrUpdateResource() {
    let resourceObj = _.cloneDeep(this.resource);
    resourceObj.files = JSON.stringify(resourceObj.files);
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.createOrEditPlanResource(this.org, this.user.id, resourceObj)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        const successMsg = (this.resourceEditMode) ? 'Resource updated successfully' : 'Resource created successfully';
        this.toastService.pop(TOAST_TYPE.success, successMsg);
        this.createOrEditResource = false;
        this.reveal.additionalResources = false;
        this.resource = {
          files: []
        };
        this.getAdditionalResources();
        this.resetUploader('resource');
        this.resetUploader('image');
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To create/update resource`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  showResource(resource) {

  }

  deleteResource(resource) {
    const data = {
      resourceId: resource.id,
      type: 'deleteResource'
    };
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', data);
  }

  deleteTemplate(template){
    const data =  {
      templateId : template.templateId,
      type : 'deleteTemplate'
    };
      this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', data);
  }

  editResource(resource) {
    this.resource = {
      files: []
    };
    this.createOrEditResource = true;
    this.resourceEditMode = true;
    this.reveal.additionalResources = true;
    this.resource = _.cloneDeep(resource);
    this.setFileUploader();
    this.setImageUploader();
  }

  getFileData(file) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.downloadDocument(this.user.id, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        window.open(response.temporaryURL);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To download document`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  removeResource(resourceId) {
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.removePlanResource(this.org, this.user.id, resourceId)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Resource deleted successfully');
        this.getAdditionalResources();
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to delete Resource`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  setFrequency($event){
    this.plan.frequency = $event.name;
  }

  oneOnOneSchedule(linkData) {
    if (linkData && linkData.link) {
      window.open(linkData.link);
    }
  }

  editOneOnOne() {
    if (this.org === 'test-taxplaniq' || this.org === 'stag-taxplaniq' || this.org === 'trialtaxplaniq') {
      this.reveal.oneOnOneEdit = true;
    }
  }

  closeOneOnOneEventEdit() {
    this.hideReveal('oneOnOneEdit');
    this.getOneOnOneEventData();
  }

  getOneOnOneEventData() {
    this.loadingService.triggerLoadingEvent(true);
    this.growthPlanService.getOneOnOneEvent(this.org, this.user.id)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        if (response && response.thumbnailUrl) {
          response.logoBg = {
            background: 'url("' + response.thumbnailUrl + '") center center no-repeat',
            'background-size': 'contain'
          };
        }
        this.oneOnOneEvent = response || {
          name: 'One on One Firm Consultation',
          description: 'A 30-minute consult with one of our Tax Experts',
          location: 'Online, Private',
          link: '',
          thumbnailUrl: ''
        };
        if (this.oneOnOneEvent.link) {
          this.oneOnOneEvent.link = JSON.parse(this.oneOnOneEvent.link);
        }
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To get one on one data`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  opentZoomLink() {
    if (this.selectedEvent.link) {
      window.open(this.selectedEvent.link);
    }
  }

  formatedTimeValue(plan) {
    let timeValue = '';
    if (plan.timeRange) {
      const [hour, minute] = plan.timeRange.split(':').map(num => parseInt(num, 10));

      let meridian = 'AM';

      if (hour >= 12) {
        meridian = 'PM';
      }
      timeValue = `${plan.timeRange} ${meridian} CT`;
    } else {
      timeValue = ''; // Clear the result if no time is selected
    }
    return timeValue;
  }

  formatCategoryName(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '_');
  }
  onGrowthCategoryImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = '../../../../images/growth-category-icons/general.png';
  }
  setGrowthPlanMarketingProgramTabFileId(){
    if(this.currentEnvironment.production){
      this.staticFileId = "aea5b19a-21e6-4384-a01c-90d3a0ba59cd";
    }else{
      this.staticFileId = "52e3a735-96ee-4849-a2df-cd342bc665b7";
    }
  }
}
